"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _memoizeOne2 = _interopRequireDefault(require("memoize-one"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _components = require("../../../../../common/components");

var _Branding = _interopRequireDefault(require("./Branding"));

var _VideoBriefCard = _interopRequireDefault(require("./VideoBriefCard"));

var _AssetsCarousel = _interopRequireDefault(require("./AssetsCarousel/AssetsCarousel"));

require("../styles/_video-brief.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var getBrandDownloader = (0, _memoizeOne2.default)(function (subBrandId) {
  return function () {
    return (0, _commonReact.downloadFile)({
      subBrandId: subBrandId
    });
  };
});

var parseJson = function parseJson() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  try {
    return JSON.parse(text);
  } catch (e) {
    return null;
  }
};

function getNumberComments(currentNumber, setNumberComments) {
  return function (number) {
    if (number === currentNumber) {
      return;
    }

    setNumberComments(number);
  };
}

function VideoBrief(_ref) {
  var history = _ref.history,
      assets = _ref.assets,
      video = _ref.video,
      clips = _ref.clips;

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      numberComments = _useState2[0],
      setNumberComments = _useState2[1];

  return (/*#__PURE__*/_react.default.createElement("div", {
      className: "video-brief"
    }, /*#__PURE__*/_react.default.createElement(_components.SectionHeader, {
      iconName: "brief",
      title: "Video Brief"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "video-brief__container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "video-brief__container__header"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "video-brief__container__header__title"
    }, video.creativeInput), /*#__PURE__*/_react.default.createElement("p", {
      className: "video-brief__container__header__date"
    }, "Last Updated ".concat((0, _moment.default)(parseInt(video.updatedAt, 10)).fromNow()))), /*#__PURE__*/_react.default.createElement(_commonReact.RichTextEditor, {
      editorState: (0, _commonReact.convertToEditorState)(parseJson(video.notesToTheEditor)),
      disabled: true
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "video-brief__cards"
    }, /*#__PURE__*/_react.default.createElement(_VideoBriefCard.default, {
      title: "Target Audience",
      text: video.targetAudience,
      labelIcon: "group"
    }), /*#__PURE__*/_react.default.createElement(_VideoBriefCard.default, {
      title: "Key Message",
      text: video.keyMessage,
      labelIcon: "intaccess"
    }), /*#__PURE__*/_react.default.createElement(_VideoBriefCard.default, {
      title: "Call-to-Action",
      text: video.callToAction,
      labelIcon: "broadcast"
    })), /*#__PURE__*/_react.default.createElement(_components.SectionHeader, {
      marginTop: true,
      iconName: "user",
      title: "Presenters"
    }), video.presenters.map(function (_ref2) {
      var presenterId = _ref2.presenterId,
          name = _ref2.name,
          title = _ref2.title,
          description = _ref2.description,
          imageKey = _ref2.imageKey;
      return (/*#__PURE__*/_react.default.createElement(_components.EntityFormBlock, {
          key: presenterId,
          className: "video-brief__contacts-block",
          imageSize: "90px",
          imageUrl: imageKey,
          defaultImageIcon: "user"
        }, /*#__PURE__*/_react.default.createElement("p", {
          className: "video-brief__contacts-block__title"
        }, name), /*#__PURE__*/_react.default.createElement("p", {
          className: "video-brief__contacts-block__subtitle"
        }, title), /*#__PURE__*/_react.default.createElement("p", {
          className: "video-brief__contacts-block__description"
        }, description))
      );
    }), /*#__PURE__*/_react.default.createElement(_components.SectionHeader, {
      iconName: "link",
      title: "Branding",
      btnText: "DOWNLOAD ALL",
      onClick: video.brandId && getBrandDownloader(video.brandId),
      marginTop: true
    }), video.brandId && /*#__PURE__*/_react.default.createElement(_Branding.default, {
      history: history,
      brandId: video.brandId
    }), /*#__PURE__*/_react.default.createElement(_components.SectionHeader, {
      iconName: "link",
      title: "Style References",
      marginTop: true
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "video-brief__style-block"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "video-brief__style-block__title"
    }, "Video Style"), /*#__PURE__*/_react.default.createElement("p", {
      className: "video-brief__style-block__subtitle"
    }, video.videoStyle || '-'), /*#__PURE__*/_react.default.createElement("p", {
      className: "video-brief__style-block__title"
    }, "Music Style"), /*#__PURE__*/_react.default.createElement("p", {
      className: "video-brief__style-block__subtitle"
    }, video.musicStyle || '-')), /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement(_AssetsCarousel.default, {
      assets: assets
    }), /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_components.SectionHeader, {
      iconName: "comments",
      title: "File Comments (".concat(numberComments, ")")
    }), /*#__PURE__*/_react.default.createElement(_commonReact.CommentsList, {
      clips: clips,
      getNumberComments: getNumberComments(numberComments, setNumberComments)
    })), /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement("div", {
      className: "video-brief__section"
    }, /*#__PURE__*/_react.default.createElement(_components.SectionHeader, {
      iconName: "link",
      title: "Linked Resources"
    }), /*#__PURE__*/_react.default.createElement(_components.SectionHeader, {
      iconName: "link",
      title: "Attachments"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "video-brief__section__container"
    }, video.linkedResources.map(function (_ref3) {
      var title = _ref3.title,
          description = _ref3.description,
          updatedAt = _ref3.updatedAt,
          imageUrl = _ref3.imageUrl;
      return (/*#__PURE__*/_react.default.createElement(_components.EntityFormBlock, {
          key: title,
          className: "video-brief__section__container__item",
          imageSize: "90px",
          imageUrl: imageUrl,
          options: []
        }, /*#__PURE__*/_react.default.createElement("p", {
          className: "video-brief__section__container__item__title"
        }, title), /*#__PURE__*/_react.default.createElement("p", {
          className: "video-brief__section__container__item__subtitle"
        }, description), /*#__PURE__*/_react.default.createElement("p", {
          className: "video-brief__section__container__item__description"
        }, "Last updated on ".concat((0, _moment.default)(updatedAt).format('YYYY/MM/DD [at] HH:MMa'))), /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
          className: "video-brief__section__container__item__btn",
          small: true,
          type: "SECONDARY"
        }, "VIEW"))
      );
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "video-brief__section__container"
    }, video.attachments.map(function (_ref4) {
      var title = _ref4.title,
          description = _ref4.description,
          imageUrl = _ref4.imageUrl;
      return (/*#__PURE__*/_react.default.createElement(_components.EntityFormBlock, {
          key: title,
          className: "video-brief__section__container__item",
          imageSize: "90px",
          imageUrl: imageUrl,
          options: []
        }, /*#__PURE__*/_react.default.createElement("p", {
          className: "video-brief__section__container__item__title"
        }, title), /*#__PURE__*/_react.default.createElement("p", {
          className: "video-brief__section__container__item__subtitle"
        }, description))
      );
    }))))
  );
}

var _default = (0, _react.memo)(VideoBrief);

exports.default = _default;